import { Link } from "react-router-dom";
import ComicCard from "@/components/feature/ComicCard";
import { comics } from "@/mocks/comics";

const newIds = ["parachute-confession", "heartbeat-signal", "convenience-night", "all-villains"];
const hotIds = ["mist-detective", "seoul-contract", "boy-agency", "morning-convenience", "desk-lovers", "frozen-time"];

export default function NewSection() {
  const fresh = newIds.map((id) => comics.find((c) => c.id === id)).filter(Boolean) as typeof comics;
  const featured = hotIds.map((id) => comics.find((c) => c.id === id)).filter(Boolean) as typeof comics;

  return (
    <>
      <section id="new" className="mx-auto max-w-[1400px] px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <p className="text-sm font-medium text-primary-600">NEW RELEASES</p>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">新番抢先看</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              近期上架的高热度新作，提前发现潜力佳作，抢先「上车」。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {fresh.map((c) => (
            <ComicCard key={c.id} comic={c} />
          ))}
        </div>
      </section>

      <section className="bg-background-100 py-14 md:py-20">
        <div className="mx-auto max-w-[1400px] px-4 md:px-6">
          <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
            <div>
              <p className="text-sm font-medium text-secondary-700">TOP RATED</p>
              <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">本周高口碑精选</h2>
              <p className="mt-2 max-w-xl text-sm text-foreground-600">
                读者打分最高的口碑之作，适合书荒时按口碑挑书。
              </p>
            </div>
          </div>

          <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
            {featured.map((c) => (
              <ComicCard key={c.id} comic={c} />
            ))}
          </div>

          <div className="mt-10 flex justify-center">
            <Link
              to="/categories"
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
            >
              浏览更多韩漫 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}